import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from '../utils/sessionManager';
import { useTokenValidation } from '../hooks/useTokenValidation';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation();
  
  // Use the token validation hook
  useTokenValidation();

  // Check if user is authenticated
  if (!isAuthenticated()) {
    // Redirect to signin page with the current location as the return URL
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute; 